import { Injectable, OnDestroy, Renderer2, Inject } from '@angular/core';
import { BehaviorSubject, fromEvent, interval, Subscription } from 'rxjs';
import {
  BoundingBox2,
  BoundingBox2FromCenterSize,
  BoundingBox2FromLRTB,
} from '../share/boundingbox2';
import { Vector2 } from 'three';
import { DOCUMENT } from '@angular/common';

// TODO: better implementation of position change detection

@Injectable()
export class CanvasService implements OnDestroy {
  private sizeSubject = new BehaviorSubject<BoundingBox2>(
    new BoundingBox2FromCenterSize(new Vector2(0, 0), new Vector2(300, 300)),
  );
  readonly size$ = this.sizeSubject.asObservable();
  // readonly domElement = document.createElement('canvas');
  public domElement = this.render.createElement('canvas');
  private subscription: Subscription;

  get size() {
    return this.sizeSubject.value;
  }
  set size(box: BoundingBox2) {
    this.sizeSubject.next(box);
  }
  constructor(private render: Renderer2, @Inject(DOCUMENT) private _dom: any) {
    // const domElement = this.render.createElement('canvas');
    // let a  = this.render;
    // console.log('a', a);
    // const a = (this.domElement as HTMLCanvasElement).getContext('2d');
    // console.log('a', a);
    // a.fillText('my text',40,40);
    this.domElement.addEventListener('resize', e => console.log(e));
    this.subscription = interval(100).subscribe(() => {
      const rect = this.domElement.getBoundingClientRect();
      const box = new BoundingBox2FromLRTB(
        rect.left,
        rect.right,
        rect.top,
        rect.bottom,
      );
      if (
        box.left !== this.size.left ||
        box.right !== this.size.right ||
        box.top !== this.size.top ||
        box.bottom !== this.size.bottom
      ) {
        this.size = box;
      }
    });
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
